import {
  Box,
  CircularProgress,
  makeStyles,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import React, { useState } from 'react';
import useCnaeContext from '../../contexts/CnaeContext';
import CardCnae from '../molecules/CardCnae';
import Filter from '../molecules/Filter';
import PaginationCnae from '../molecules/PaginationCnae';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import FilterNotFound from '../molecules/FilterNotFound';

const useStyles = makeStyles((theme) => ({
  filterHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',

    '& .MuiTypography-h5': {
      fontWeight: 'normal'
    }
  },
  containerLoading: {
    opacity: 0.2,
    pointerEvents: 'none'
  },
  loading: {
    position: 'absolute',
    top: '100px',
    left: '46.5%',
  },
  wrapperLoading: {
    position: 'relative',
  },
  hideLoader: {
    display: 'none'
  },
}));

export default function CnaeOptions({ setOpenDrawer, noFilter }) {
  const classes = useStyles();
  const { cnaes, currentCnae, paginationParams } = useCnaeContext();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));
  const [loading, setLoading] = useState(false);
  const [filterError, setFilterError] = useState(false);
  const { setFilters } = useCnaeContext();

  function selectCnae() {
    if (matches) {
      setOpenDrawer(true);
    }
  }

  function clearFilters() {
    setFilters({
      ambiguo: false,
      impeditivo: false,
      permitido: false
    });
    setFilterError(false);
  }

  return (

    <>
      <Box className={classes.wrapperLoading}>
        <CircularProgress className={clsx(classes.loading, !loading && classes.hideLoader)} />
      </Box>
      <Box className={loading && classes.containerLoading}>
        <Box className={classes.filterHeader}>
          <Typography variant={'h5'} component={'span'} color={'inherit'}>
            Resultado
          </Typography>
          {!noFilter && <Filter setFilterError={setFilterError} loading={loading} setLoading={setLoading} />}
        </Box>
          <Box style={{ width: '100%' }}>
            {filterError
              ? (
              <FilterNotFound clearFilters={clearFilters} />
                )
              : (
              <>
                {cnaes.map((cnae, index) => (
                  <CardCnae
                    cnae={cnae}
                    key={cnae._id}
                    isSelected={currentCnae._id === cnae._id }
                    onClick={() => selectCnae()}
                    timeout={(index + 1) * 100}
                  />
                ))}
              </>
                )}
        </Box>
        <Box>
          {paginationParams.total > 1 && !filterError && <PaginationCnae setLoading={setLoading} />}
        </Box>
      </Box>
    </>
  );
}

CnaeOptions.propTypes = {
  setOpenDrawer: PropTypes.func.isRequired,
  noFilter: PropTypes.bool.isRequired
};
